import axios from "axios";

// =====================================================================
// Static / serverless build — no backend, no MongoDB.
// All lead capture happens client-side via EmailJS.
// =====================================================================

const EMAILJS_ENDPOINT = "https://api.emailjs.com/api/v1.0/email/send";
const PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;
const SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
const TO_EMAIL = "shettydivy2@gmail.com";

const sendEmailJS = async (template_params) => {
  if (!PUBLIC_KEY || !SERVICE_ID || !TEMPLATE_ID) {
    return {
      ok: false,
      skipped: true,
      error:
        "EmailJS not configured. Set REACT_APP_EMAILJS_* in .env before build.",
    };
  }
  try {
    const res = await axios.post(
      EMAILJS_ENDPOINT,
      {
        service_id: SERVICE_ID,
        template_id: TEMPLATE_ID,
        user_id: PUBLIC_KEY,
        template_params,
      },
      { headers: { "Content-Type": "application/json" } }
    );
    return { ok: true, data: res.data };
  } catch (e) {
    const detail = e?.response?.data || e?.message || "Unknown error";
    return {
      ok: false,
      error: typeof detail === "string" ? detail : JSON.stringify(detail),
    };
  }
};

// ---- Lead form ----
export const sendLeadEmail = (data) =>
  sendEmailJS({
    subject: "New Qualified Lead From Website",
    to_email: TO_EMAIL,
    name: data.full_name || "",
    business_name: data.business_name || "",
    email: data.email || "",
    phone: data.phone || "",
    business_type: data.business_type || "",
    current_website: data.has_website || "",
    monthly_revenue: data.monthly_revenue || "",
    budget: data.budget || "",
    timeline: data.timeline || "",
    services: Array.isArray(data.services) ? data.services.join(", ") : "",
    challenge: data.biggest_challenge || "",
    message: data.project_details || "",
  });

// ---- Contact form ----
export const sendContactEmail = (data) =>
  sendEmailJS({
    subject: "New Contact Message From Website",
    to_email: TO_EMAIL,
    name: data.name || "",
    business_name: "",
    email: data.email || "",
    phone: data.phone || "",
    business_type: "",
    current_website: "",
    budget: "",
    timeline: "",
    services: "",
    challenge: "",
    message: data.message || "",
  });
